module.exports = __webpack_public_path__ + "static/media/CommunityMapPlaceholder.04dd6fd2.png";